import { PRACTICE_AREAS } from "@/lib/site";
import { motion } from "framer-motion";

export const PracticeAreas = () => (
  <section id="practice" data-testid="practice-section" className="bg-[#0A1128] bg-noise relative py-24 md:py-36">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="mb-16">
        <div className="overline text-[#D4AF37]">/ Practice Areas</div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#D4AF37]/20">
        {PRACTICE_AREAS.map((p, i) => (
          <motion.div key={p.n} data-testid={`practice-item-${p.n}`}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-5%" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.06, ease: [0.33, 1, 0.68, 1] }}
            className="group relative border-r border-b border-[#D4AF37]/20 p-8 md:p-10 hover:bg-white/[0.03] transition-colors">
            <span className="font-mono-meta text-[#D4AF37]/70 text-sm">{p.n}</span>
            <h3 className="font-serif-display text-2xl md:text-3xl text-white mt-4 mb-3 group-hover:text-[#D4AF37] transition-colors">{p.title}</h3>
            <p className="font-body text-white/55 text-sm leading-relaxed">{p.desc}</p>
            <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-[#D4AF37] group-hover:w-full transition-all duration-500" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
